export const USER_ERROR_CODES = {
    'User.NotEnoughDataFromExternalAuth': {
        code: 'User.NotEnoughDataFromExternalAuth',
        title: 'Insufficient Data',
        description: 'Not enough data to sign in via external service. Please complete your profile.',
    },
    'User.AlreadyBlocked': {
        code: 'User.AlreadyBlocked',
        title: 'User Blocked',
        description: 'Your account has been blocked. Please contact support.',
    },
    'User.WrongAppType': {
        code: 'User.WrongAppType',
        title: 'Incorrect App Type',
        description: 'You are using an unsupported application.',
    },
    'User.ExternalAuthFailed': {
        code: 'User.ExternalAuthFailed',
        title: 'External Authorization Error',
        description: 'Failed to authorize via external service.',
    },
    'User.AgeLowerThanEighteen': {
        code: 'User.AgeLowerThanEighteen',
        title: 'Age Under 18',
        description: 'You must be at least 18 years old to use this service.',
    },
};
export function getUserErrorInfoByCode(code) {
    return USER_ERROR_CODES[code];
}
